import { useQuery } from "react-query";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import useShippingOps from "$hooks/useShippingOps";
import { useStyles } from "./TreatmentTab.styles";
import ShippingRecordItem from "$components/ShippingRecord/ShippingRecordItem";
import { appState } from "$store";

import { FilterForm } from "./FilterForm";
import {
  DispositionType,
  PreparationOrderStatus,
  ShippingRecord,
  ShippingRecordStatus,
} from "$types";
import { Loader } from "$components/Layout/Loader";
import { usePopin } from "$components/Popin/usePopin";
import { AddOpInRepository } from "$components/ShippingRecord/AddOpInRepository";
import { SHIPPING_OPS_PER_PAGE } from "$utils/constants";
import { ShippingRecordService } from "$services";
import useDebounceValue from "$hooks/useDebounceValue";
import { CacheInvalidationAction } from "$utils/cache";

const defaultValuesFilter = {
  status: PreparationOrderStatus.PREPARED,
  shippingLocation: "",
  deliveryLocation: "",
  startDate: null,
  endDate: null,
  code: "",
  showDisabled: true,
  refPrepWarehouse: "",
  onlyWithParcel: true,
};

export const ShipmentTreatmentPanel = ({ urlParams, handleUrlParams }: any) => {
  const classes = useStyles();
  const { filter: companySidebarFilter } = useSelector(appState);
  const paramsToUrl = {};
  Array.from((urlParams as URLSearchParams).entries()).forEach(
    ([key, value]) => {
      paramsToUrl[key] = value === "null" ? null : value;
    }
  );
  const [filters, setFilters] = useState<any>({
    ...defaultValuesFilter,
    ...paramsToUrl,
    ...{
      onlyWithParcel: !urlParams.get("onlyWithParcel")
        ? defaultValuesFilter.onlyWithParcel
        : urlParams.get("onlyWithParcel") === "true",
    },
  });
  const [selectedOPs, setSelectedOPs] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(SHIPPING_OPS_PER_PAGE);
  const debouncedFilters = useDebounceValue(filters, 500);
  const {
    ops,
    isLoading: isLoadingOps,
    total,
  } = useShippingOps(page + 1, rowsPerPage, {
    status: debouncedFilters.status,
    ...(companySidebarFilter?._id
      ? { company: companySidebarFilter.name }
      : debouncedFilters.company && debouncedFilters.company !== "null"
      ? { company: debouncedFilters.company }
      : {}),
    code: debouncedFilters.code,
    refPreparationWarehouse: debouncedFilters.refPreparationWarehouse,
    warehouseName: debouncedFilters.warehouseName,
    dockyardCode: debouncedFilters.dockyardCode,
    startDate: debouncedFilters.shippingStartDate,
    endDate: debouncedFilters.shippingEndDate,
    onlyWithParcel: debouncedFilters.onlyWithParcel,
    dispositionDateType: debouncedFilters.dispositionDateType,
  });
  const { Popin, PopinProps, togglePopin } = usePopin();

  const [selectedOpToAddInDrawer, setSelectedOpToAddInDrawer] =
    useState(undefined);

  const getShipmentsWithPopulateOpsFilters = {
    ...(companySidebarFilter ? { company: companySidebarFilter._id } : {}),
    status: ShippingRecordStatus.DRAFT,
  };

  const { data: draftShippingRecords, isLoading } = useQuery(
    [
      CacheInvalidationAction.GET_SHIPMENTS_WITH_POPULATE_OPS,
      getShipmentsWithPopulateOpsFilters,
    ],
    () =>
      ShippingRecordService.getShipmentsWithPopulateOps(
        getShipmentsWithPopulateOpsFilters
      ),
    {
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const filteredOps =
    ops?.filter((op) => op.shipType !== DispositionType.COLLECTED) || [];

  return (
    <>
      <Box className={classes.beforeOpTable}>
        <h3>Traitement des OP</h3>
      </Box>

      <FilterForm
        ops={filteredOps}
        isLoading={isLoadingOps}
        disabledShiping={ops?.length === 0}
        setSelectedOpToAddInDrawer={setSelectedOpToAddInDrawer}
        togglePopin={togglePopin}
        // handleChangePage={handleChangePage}
        page={page}
        setPage={setPage}
        total={total}
        filters={filters}
        setFilters={setFilters}
        companySidebarFilter={companySidebarFilter}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        urlParams={urlParams}
        handleUrlParams={handleUrlParams}
        selectedOPs={selectedOPs}
        setSelectedOPs={setSelectedOPs}
      />

      <Box>
        <h3>Dossiers</h3>
        {isLoading ? (
          <Loader />
        ) : (
          draftShippingRecords?.map(
            (shippingRecord: ShippingRecord, index: number) => (
              <ShippingRecordItem
                key={shippingRecord.id}
                shippingRecord={shippingRecord}
                expanded={index === draftShippingRecords.length - 1}
              />
            )
          )
        )}
      </Box>

      <Popin {...PopinProps}>
        <AddOpInRepository
          togglePopin={togglePopin}
          op={selectedOpToAddInDrawer}
        />
      </Popin>
    </>
  );
};

export default defaultValuesFilter;
